import type { BubblePointPressurePSIACalculator } from "../../d";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const bubblePointPressurePSIACalculator: BubblePointPressurePSIACalculator =
  params => {
    const { temperatureInRankine, gasSpecificGravity } = params;
    const { molFractionOfGas_y_g } = solutionGasRsoCalculator(params);

    // Updated Bubble Point Pressure Factor - Pf
    // static/Fluid.Schutff.Kevin.Edition_with.Lasater.changes.xlsx
    // Pf = IF(y_g <= 0.6, 0.83918*10^(1.17664*y_g)*y_g^0.57246, 0.83918*10^(1.108*y_g)*y_g^0.31109)
    let bubblePointPressureFactor_Pf: number;
    if (molFractionOfGas_y_g <= 0.6) {
      bubblePointPressureFactor_Pf =
        0.83918 *
        Math.pow(10, 1.17664 * molFractionOfGas_y_g) *
        Math.pow(molFractionOfGas_y_g, 0.57246);
    } else {
      bubblePointPressureFactor_Pf =
        0.83918 *
        Math.pow(10, 1.108 * molFractionOfGas_y_g) *
        Math.pow(molFractionOfGas_y_g, 0.31109);
    }

    // Bubble Point Pressure (Lasater Pb) (psi)
    // Pb = (Pf * TemperatureInRankine) / gasSpecificGravity
    const bubblePointPressurePSIA = gasSpecificGravity
      ? (bubblePointPressureFactor_Pf * temperatureInRankine) /
        gasSpecificGravity
      : 0;

    return {
      bubblePointPressurePSIA,
      bubblePointPressureFactor_Pf
    };
  };
